import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "WisdomArea",
  id: "wisdomArea"
}
const _hoisted_2 = ["innerHTML"]

import { onMounted, reactive } from "vue";
import Proxy from "../api/proxy";
import { Message } from "../models/Message";

interface State {
  Title: string | null;
  HtmlContent: string | null;
  isInvisible: boolean;
  isFadein: boolean;
  isFadeout: boolean;
  messages: Message[];
  currentMessageIndex: number;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const pickNextTime = 6000;
const fadeoutTime = 20000;

const state = reactive<State>({
  Title: null,
  HtmlContent: "",
  isInvisible: true,
  isFadein: false,
  isFadeout: false,
  messages: [],
  currentMessageIndex: -1,
});
const proxy = new Proxy();

onMounted(() =>
  proxy
    .wisdoms()
    .then((response) => {
      state.messages = response;
      pickNextMessage();
    })
    .catch()
);

function pickNextMessage(): void {
  if (state.currentMessageIndex === -1) {
    state.currentMessageIndex = getRandomInt(state.messages.length);
  } else {
    if (state.currentMessageIndex === state.messages.length - 1) {
      state.currentMessageIndex = 0;
    } else {
      state.currentMessageIndex++;
    }
  }
  setFadein();
  setMessage(state.currentMessageIndex);
}

function setMessage(index: number): void {
  state.Title = state.messages[index].title;
  let html = "";
  state.messages[index].lines.forEach((line) => {
    html += line + "<br/>";
  });
  state.HtmlContent = html;
}

function setFadein(): void {
  state.isInvisible = false;
  state.isFadein = true;
  state.isFadeout = false;
  setTimeout(setFadeout, fadeoutTime);
}

function setFadeout(): void {
  state.isInvisible = false;
  state.isFadein = false;
  state.isFadeout = true;
  setTimeout(pickNextMessage, pickNextTime);
}

function getRandomInt(max: number) {
  return Math.floor(Math.random() * max);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["WiseHeader", {
        invisible: _unref(state).isInvisible,
        fadein: _unref(state).isFadein,
        fadeout: _unref(state).isFadeout,
      }])
    }, _toDisplayString(_unref(state).Title), 3),
    _createElementVNode("div", {
      class: _normalizeClass(["WiseMessage", {
        invisible: _unref(state).isInvisible,
        fadein: _unref(state).isFadein,
        fadeout: _unref(state).isFadeout,
      }]),
      innerHTML: _unref(state).HtmlContent
    }, null, 10, _hoisted_2)
  ]))
}
}

})